// import { useLocation, useNavigate } from "react-router-dom";
// import React, { useState, useRef, useEffect, use } from "react";
// import { Link } from "react-router-dom";
// import $ from "jquery";
// import "datatables.net";
// import "datatables.net-responsive";
// import { showSuccess, showError } from "toast/toast";
// import { ShippingCost } from "types";
// import SignageAddShippingCost from "./SignageAddShippingCost";
// import SignageEditShippingCost from "./SignageEditShippingCost";

// const SignageShippingCosts = () => {
//   const [shippingCosts, setShippingCosts] = useState<ShippingCost[]>([]);
//   const [error, setError] = useState<string>("");
//   const [loading, setLoading] = useState(true);
//   const [deleting, setDeleting] = useState<string | null>(null); // Track deletion in progress
//   const token = getAuthCookie("sessionToken");
//   const [toastShown, setToastShown] = useState(false);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [selectedShippingId, setSelectedShippingId] = useState<string | null>(null);
//   const prevShippingModalState = useRef(false);
//   const location = useLocation();
//   const navigate = useNavigate();

//   const fetchShippingCosts = async () => {
//     try {
//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/shipping-costs`,
//         {
//           method: "GET",
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       const data = await response.json();
//       console.log("Shipping Costs Response:", data);
//       setShippingCosts(data);
//     } catch (err) {
//       setError(
//         err instanceof Error ? err.message : "An unknown error occurred"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };


//   useEffect(() => {
//     fetchShippingCosts();
//   }, [token]);
//   useEffect(() => {
//     const justClosed =
//       prevShippingModalState.current &&
//       !showAddModal &&
//       !showEditModal;

//     if (justClosed) {
//       fetchShippingCosts(); // ✅ Refresh data
//     }

//     prevShippingModalState.current = showAddModal || showEditModal;
//   }, [showAddModal, showEditModal]);
//   // if (dynamicCosts?.length === 0) {
//   //   return <div>Loading...</div>;
//   // }

//   useEffect(() => {
//     if (shippingCosts != null && shippingCosts.length > 0) {
//       const table = $("#transactions").DataTable({
//         responsive: false,
//         destroy: true,
//         lengthChange: false,
//         ordering: false,
//         searching: false,
//       });

//       return () => {
//         table.destroy();
//       };
//     }
//   }, [shippingCosts]);

//   const deleteShippingCost = async (id: string) => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_API_URL}/shipping-costs/${id}`, {
//         method: "DELETE",
//         headers: {
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       if (!response.ok) {
//         showError("Failed to delete shipping cost");
//         throw new Error("Failed to delete shipping cost");
//       }

//       showSuccess("Shipping cost deleted successfully!");
//       navigate(0);

//     } catch (error) {
//       console.error("Error deleting shipping cost:", error);
//       throw error;
//     }
//   };


//   //   if (loading) {
//   //     return <div>Loading...</div>;
//   //   }

//   return (
//     <div className="content">
//       {/* <h2 className="d-flex align-items-center justify-content-center">Shipping </h2> */}
//       <div className="d-flex  justify-content-between align-items-center border-bottom pb-3  page-container">
//         <h4 className="mb-0 fw-bold">Shipping</h4>

//         <div className="d-flex gap-3 align-items-center">
//           {/* Search Bar */}
//           {/* <div className="input-group" style={{ width: "230px", height: "40px", marginRight: "30px" }}>
//                   <span className="input-group-text bg-white border-end-0 p-2 left-radius">
//                     <i className="ri-search-line fs-15"></i>
//                   </span>
//                   <input
//                     type="text"
//                     className="form-control border-start-0 ps-0 right-radius"
//                     placeholder="Search by Name and Email"
//                     value={searchInput}
//                     onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchInput(e.target.value)}
//                     onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
//                       if (e.key === "Enter") {
//                         setGlobalFilter(searchInput);
//                       }
//                     }}
//                     style={{ borderColor: "#cccccc" }}
//                   />
//                 </div> */}

//           {/* Import/Export Button */}
//           {/* <button className="btn btn-outline-dark d-flex align-items-center">
//             <i className="ri-download-2-line me-1"></i> Import & Export
//           </button> */}

//           {/* Create Button */}
//           <Link
//             to="/signage/ShippingCost"
//             state={{ type: "add" }}
//             className="btn btn-primary float-right"
//           >
//             Add Shipping Cost
//           </Link>
//           {/* <button
//             className="btn btn-primary"
//             onClick={() => setShowAddModal(true)}
//           >
//             Add Shipping Cost
//           </button> */}
//         </div>
//       </div>
//       <div className="row justify-content-center">
//         <div className="col-md-12 col-lg-12 col-xl-12">
//           <div className="">
//             <div className="">
//               <div className="table-container">
//                 {/* <div className="text-end">
//                   <button
//                     className="btn btn-primary"
//                     onClick={() => setShowAddModal(true)}
//                   >
//                     Add Shipping Cost
//                   </button>
//                 </div> */}

//                 {/* <div className="text-end">
//             <Link
//               to="/signage/shipping/addShippingCost"
//               className="btn btn-primary float-right"
//             >
//               Add Shipping Cost
//             </Link>
//           </div> */}
//                 <table
//                   id="transactions"
//                   className="table dt-responsive nowrap table-striped align-middle"
//                   style={{ width: "100%" }}
//                 >
//                   <thead>
//                     <tr className="table-light">
//                       <th className="text-center table-headers">S.No.</th>
//                       <th className="text-center table-headers">Name</th>
//                       <th className="text-center table-headers">Description </th>
//                       <th className="text-center table-headers">Cost</th>
//                       <th className="text-center table-headers">Status</th>
//                       <th className="text-center table-headers">Actions</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {shippingCosts != null &&
//                       shippingCosts?.map((shipping, index) => (
//                         <tr key={shipping._id}>
//                           <td className="text-center table-cells">{index + 1}</td>
//                           <td className="text-center table-cells">{shipping.name}</td>
//                           <td className="text-center table-cells">{shipping.description}</td>
//                           {
//                             shipping.cost ? (
//                               <td className="text-center table-cells">${Number(shipping.cost).toFixed(2)}</td>
//                             ) : (
//                               <td className="text-center table-cells">Free</td>
//                             )
//                           }
//                           {/* <td className="text-center table-cells">${Number(shipping.cost).toFixed(2)}</td> */}
//                           {/* <td className="text-center table-cells">{shipping.status}</td> */}
//                           <td className="text-center table-cells">
//                             <input
//                               type="radio"
//                               className={
//                                 shipping.status
//                                   ? "status-radio status-radio-active"
//                                   : "status-radio status-radio-inactive"
//                               }
//                               checked
//                               readOnly
//                             />
//                           </td>
//                           <td className="text-center table-cells">
//                             <div className="d-flex justify-content-center align-items-center gap-2">
//                               <Link
//                                 to={`/signage/ShippingCost/${shipping._id}`}
//                                 state={{ type: "edit" }}
//                                 className="border-0 p-0"
//                               >
//                                 <i className="ri-pencil-fill fs-18"></i>
//                               </Link>
//                               {/* <button
//                                 type="button"
//                                 className="border-0 p-0" onClick={() => {
//                                   setSelectedShippingId(shipping._id);
//                                   setShowEditModal(true);
//                                   console.log("Selected Shipping ID:", shipping._id);
//                                 }}
//                               >
//                                 <i className="ri-pencil-fill fs-18"></i>
//                               </button> */}

//                               <button
//                                 type="button"
//                                 className="border-0 p-0" onClick={() =>
//                                   window.confirm("Are you sure you want to delete this cost?") &&
//                                   deleteShippingCost(shipping._id)
//                                 }
//                               >
//                                 <i className="ri-delete-bin-line text-danger fs-18"></i>
//                               </button>
//                             </div>
//                           </td>

//                         </tr>
//                       ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {showAddModal && (
//         <div
//           className="modal fade show d-block"
//           tabIndex={-1}
//           role="dialog"
//           style={{
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             zIndex: 1050,
//           }}
//         // onClick={() => setShowAddModal(false)}
//         >
//           <div
//             className="modal-dialog "
//             role="document"
//             onClick={(e) => e.stopPropagation()}
//           >


//             {showAddModal && (
//               <div className="modal d-block" onClick={() => setShowAddModal(false)}>
//                 <div
//                   className="modal-dialog top-8"
//                   role="document"
//                   onClick={(e) => e.stopPropagation()} // prevent closing on inner click
//                 >
//                   <div className="modal-content">
//                     <div className="modal-body">
//                       <SignageAddShippingCost
//                         // onGroupAdd={handleGroupAdded}
//                         onClose={() => setShowAddModal(false)} // ✅ pass to child if needed
//                       />
//                       <div className="d-flex justify-content-end mt-3 ">
//                         <button
//                           type="button"
//                           className="btn btn-secondary"
//                           onClick={() => setShowAddModal(false)}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//           </div>
//         </div>
//       )}


//       {showEditModal && selectedShippingId && (
//         <div
//           className="modal fade show d-block"
//           tabIndex={-1}
//           role="dialog"
//           style={{
//             backgroundColor: "rgba(0, 0, 0, 0.5)",
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             zIndex: 1050,
//           }}
//         // onClick={() => setShowEditModal(false)}
//         >
//           <div
//             className="modal-dialog "
//             role="document"
//             onClick={(e) => e.stopPropagation()}
//           >


//             {showEditModal && (
//               <div className="modal d-block" onClick={() => setShowEditModal(false)}>
//                 <div
//                   className="modal-dialog top-8"
//                   role="document"
//                   onClick={(e) => e.stopPropagation()} // prevent closing on inner click
//                 >
//                   <div className="modal-content">
//                     <div className="modal-body">
//                       <SignageEditShippingCost
//                         costId={selectedShippingId}
//                         onClose={() => setShowEditModal(false)}
//                       />
//                       <div className="d-flex justify-content-end mt-3">
//                         <button
//                           type="button"
//                           className="btn btn-secondary"
//                           onClick={() => setShowEditModal(false)}
//                         >
//                           Cancel
//                         </button>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             )}

//           </div>
//         </div>
//       )}





//     </div>
//   );
// };

// export default SignageShippingCosts;




import React, { ChangeEvent, KeyboardEvent, useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Row,
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import { DesktopTableParts, MobileCardsOnly } from "components/TableandMobilecomponent";
import {
  DesktopTableLoader,
  MobileCardsLoader,
  DataTableStatus,
} from "components/DataTableLoader";
import TablePaginationControls from "components/TableandmobilePaginationcontrol";
import { showError, showSuccess } from "toast/toast";
import { ViewIconButton, EditIconButton, DeleteIconButton } from "components/DatatablesActionIcons";
import DeleteConfirmModal from "components/ToolTips/DeleteConfirmModal";
import { getAuthCookie } from "../../utils/authCookies";
import { useModuleActionPermissions } from "hooks/useModuleActionPermissions";
import { MODULE_PERMISSION_NAMES } from "utils/moduleActionPermissions";

// Normalized row type for the table
export type ShippingCostRow = {
  id: string;
  name: string;
  description?: string;
  cost?: number; // for FLAT_RATE and PER_ITEM
  is_free?: boolean;
  calculation_type?: "WEIGHT_BASED" | "FLAT_RATE" | "PER_ITEM";
  weight_ranges?: Array<{ up_to_lbs: number; price: number }>;
  above_weight?: number;
  out_of_range_message?: string;
  status: boolean | string; // "active"/"inactive" or boolean
};

// Fuzzy text filter like your Brand list
function fuzzyTextFilter<TData>(row: Row<TData>, columnId: string, filterValue: string) {
  const raw = row.getValue(columnId);
  const value = (typeof raw === "boolean" ? (raw ? "Active" : "Inactive") : String(raw ?? "")).toLowerCase();
  return value.includes((filterValue ?? "").toLowerCase());
}

const columnHelper = createColumnHelper<ShippingCostRow>();

const normalizeShippingCostRow = (d: any): ShippingCostRow => ({
  id: d?.id || d?._id,
  name: d?.name ?? "",
  description: d?.description ?? "",
  is_free: d?.is_free ?? false,
  calculation_type: d?.calculation_type,
  cost: typeof d?.cost === "number" ? d.cost : undefined,
  weight_ranges: d?.weight_ranges || [],
  above_weight: d?.above_weight,
  out_of_range_message: d?.out_of_range_message,
  status: d?.status ?? "inactive",
});

const SignageShippingCosts: React.FC = () => {
  const token = getAuthCookie("sessionToken") || "";
  const userId = getAuthCookie("userId") || "";
  const location = useLocation();
  const isSignageTeammember = location.pathname.includes('/signageteammember');
  const baseRoute = isSignageTeammember ? '/signageteammember' : '/signage';
  const { canCreate, canEdit, canDelete } = useModuleActionPermissions(
    MODULE_PERMISSION_NAMES.shipping_methods_cost
  );

  const [rows, setRows] = useState<ShippingCostRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [rowCount, setRowCount] = useState(0);
  const [deleting, setDeleting] = useState<string | null>(null);
  const [deleteTarget, setDeleteTarget] = useState<{ id: string; name: string } | null>(null);

  const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 10 });
  const [globalFilter, setGlobalFilter] = useState("");
  const [searchInput, setSearchInput] = useState(globalFilter);
  const fetchRequestIdRef = useRef(0);
  const hasLoadedDataRef = useRef(false);

  useEffect(() => {
    let ignore = false;

    async function load() {
      const requestId = ++fetchRequestIdRef.current;
      const showInitialLoader = !hasLoadedDataRef.current;
      if (!token || !userId) {
        if (requestId !== fetchRequestIdRef.current) return;
        setRows([]);
        setRowCount(0);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const body = {
          page: pagination.pageIndex + 1,
          limit: pagination.pageSize,
          search: globalFilter,
          filters: {},
          sort: { field: "created_at", order: "desc" },
          fields: [],
        };

        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/shipping-costs/datatable?user_id=${encodeURIComponent(userId)}`,
          {
            method: "POST",
            headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
            body: JSON.stringify(body),
          }
        );

        const json: any = await res.json();
        if (!res.ok || json?.error) {
          const msg = json?.error || json?.message || "Failed to fetch shipping costs";
          showError(msg);
          throw new Error(msg);
        }

        if (!ignore && requestId === fetchRequestIdRef.current) {
          const data = Array.isArray(json?.data) ? json.data : [];
          setRows(data.map(normalizeShippingCostRow));
          setRowCount(Number(json?.total) || 0);
          hasLoadedDataRef.current = true;
        }
      } catch {
        if (!ignore && requestId === fetchRequestIdRef.current) {
          setRows([]);
          setRowCount(0);
        }
      } finally {
        if (!ignore && requestId === fetchRequestIdRef.current) {
          setLoading(false);
        }
      }
    }

    load();
    return () => {
      ignore = true;
    };
  }, [token, userId, globalFilter, pagination.pageIndex, pagination.pageSize, deleting]);

  const handleDeleteClick = (row: ShippingCostRow) => {
    setDeleteTarget({ id: row.id, name: row.name || "Shipping Cost" });
  };

  const handleDeleteCancel = () => {
    setDeleteTarget(null);
  };

  const handleDeleteConfirm = async () => {
    if (!deleteTarget) return;
    await handleDelete(deleteTarget.id);
    setDeleteTarget(null);
  };

  // ===== Delete =====
  const handleDelete = async (id: string) => {
    setDeleting(id);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/shipping-costs/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      });
      if (!res.ok) throw new Error("Failed to delete shipping cost");
      showSuccess("Shipping cost deleted successfully!");
      setRows(prev => prev.filter(r => r.id !== id));
      setRowCount(n => Math.max(0, n - 1));
    } catch (e) {
      showError("Failed to delete the shipping cost.");
    } finally {
      setDeleting(null);
    }
  };

  // ===== Columns (EXACT Add Brand data table model) =====
  const columns = useMemo(() => {
    return [
      columnHelper.display({
        id: "serial",
        header: () => <div className="th-text text-center S-No">S.No.</div>,
        cell: (info) => (
          <div className="text-sm text-center S-No">{pagination.pageIndex * pagination.pageSize + info.row.index + 1}</div>
        ),
        enableGlobalFilter: false,
      }),
      columnHelper.accessor((row) => `${row?.name ?? ""}` as string, {
        id: "name",
        header: () => <div className="th-text text-center S-No-2">Name</div>,
        cell: (info) => <div className="text-sm text-center S-No-2">{info.getValue()}</div>,
        filterFn: fuzzyTextFilter,
        enableGlobalFilter: true,
      }),
      columnHelper.display({
        id: "description",
        header: () => <div className="th-text text-center">Description</div>,
        cell: (info) => <div className="text-sm text-center">{info.row.original.description || "—"}</div>,
        enableGlobalFilter: true,
      }),
      columnHelper.display({
        id: "cost",
        header: () => <div className="th-text text-center">Cost</div>,
        cell: (info) => {
          const row = info.row.original;
          const { calculation_type, is_free, cost, weight_ranges, above_weight } = row;
          
          // Handle WEIGHT_BASED calculation type
          if (calculation_type === "WEIGHT_BASED") {
            if (is_free) {
              return <div className="text-sm text-center">Free</div>;
            }
            
            if (!weight_ranges || weight_ranges.length === 0) {
              return <div className="text-sm text-center">—</div>;
            }
            
            return (
              <div className="text-sm text-center">
                <div className="d-flex flex-column gap-1 align-items-center">
                  {/* {weight_ranges.map((range, idx) => (
                    <div key={idx} className="small">
                      Up to {range.up_to_lbs} lbs: ${Number(range.price).toFixed(2)}
                      ${Number(range.price).toFixed(2)}
                    </div>
                  ))} */}
                  {above_weight !== undefined && (
                    <div className="text-sm text-center">
                      {/* Above {weight_ranges[weight_ranges.length - 1]?.up_to_lbs || 0} lbs: ${Number(above_weight).toFixed(2)} */}
                      ${Number(above_weight).toFixed(2)}
                    </div>
                  )}
                </div>
              </div>
            );
          }
          
          // Handle FLAT_RATE and PER_ITEM
          if (is_free) {
            return <div className="text-sm text-center">Free</div>;
          }
          
          if (cost && cost > 0) {
            return <div className="text-sm text-center">${Number(cost).toFixed(2)}</div>;
          }
          
          return <div className="text-sm text-center">Free</div>;
        },
        enableGlobalFilter: true,
      }),
      columnHelper.accessor("status", {
        header: () => <div className="th-text text-center">Status</div>,
        cell: (info) => {
          const value = info.getValue() as string | boolean;
          const norm = typeof value === "string" ? value.toLowerCase() : value;
          const isActive = norm === true || norm === "true" || norm === "active";
          const className = isActive ? "status-radio status-radio-active" : "status-radio status-radio-inactive";
          return (
            <div className="text-sm text-center">
              <input type="radio" className={className} checked={isActive} readOnly />
            </div>
          );
        },
        enableGlobalFilter: true,
      }),
      columnHelper.display({
        id: "actions",
        header: () => <div className="th-text text-center">Actions</div>,
        cell: (info) => {
          const r = info.row.original;
          if (!canEdit && !canDelete) return null;
          return (
            <div className="d-flex align-items-center justify-content-center gap-2">
              {canEdit && (
                <EditIconButton
                  to={`${baseRoute}/ShippingCost/${r.id}`} state={{ type: "edit" }} className="icon-square" title="Edit" />
              )}

              {canDelete && (
                <DeleteIconButton
                  onClick={() => handleDeleteClick(r)}
                  className="icon-square danger"
                  title="Delete"
                  disabled={deleting === r.id}
                />
              )}
            </div>
          );
        },
      }),
    ];
  }, [baseRoute, deleting, pagination, canEdit, canDelete]);

  // ===== Table instance =====
  const table = useReactTable({
    data: rows,
    columns,
    pageCount: Math.ceil(rowCount / pagination.pageSize) || 1,
    state: { pagination, globalFilter },
    manualPagination: true,
    manualFiltering: true,
    onPaginationChange: setPagination,
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
  });

  const showTableLoader = loading;

  return (
    <div className="content container">
      {/* Top actions */}
      <div className="d-flex justify-content-between align-items-center pb-3 mb-2 py-2">
        <div />
        {/* <div className="d-flex gap-3 align-items-center">
          <Link to={`${baseRoute}/ShippingCost`} state={{ type: "add" }} className="btn btn-primary table-addbutton">+ Add Shipping Cost</Link>
        </div> */}
      </div>

      {/* Header w/ search (same as Add Brand list) */}
      <div className="po-header mb-4 shadow-border-datatables">
        <div className="po-top d-flex justify-content-between align-items-start align-items-md-center flex-wrap gap-2">
          <div className="po-title-wrap me-2 d-flex align-items-center">
            <h4 className="po-title mb-0">Shipping Costs</h4>
          </div>
          <div className="po-tools d-flex align-items-center flex-wrap gap-2 ms-auto">
            <div className="input-group po-search" style={{ width: "clamp(240px, 28vw, 360px)" }}>
              <span className="input-group-text"><i className="ri-search-line" /></span>
              <input
                type="text"
                className="form-control"
                placeholder="Search by name or status"
                value={searchInput}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchInput(e.target.value)}
                onKeyDown={(e: KeyboardEvent<HTMLInputElement>) => {
                  if (e.key === "Enter") setGlobalFilter(searchInput);
                }}
              />
            </div>
                      {canCreate && (
                        <Link to={`${baseRoute}/ShippingCost`} state={{ type: "add" }} className="btn btn-primary table-addbutton">+ Add Shipping Cost</Link>
                      )}

          </div>
        </div>
      </div>

      {/* Data Table card */}
      <div className="card overflow-hidden production-card box-shadow-datatables shadow-border-datatables">
        <div className="align-items-center bg-white border-bottom d-flex justify-content-between px-4 py-4">
          <h5 className="mb-0">Shipping Costs</h5>
        </div>
        <hr className="mb-2" style={{ borderTop: "none" }} />

        {/* Desktop */}
        <div className="rdt-desktop">
          <div className="production-scroll" style={{ "--rdt-min": "1100px" } as React.CSSProperties}>
            <table className="table production-table align-middle mb-0 table-1">
              {showTableLoader ? (
                <DesktopTableLoader table={table} message="Loading shipping costs…" />
              ) : (
                <DesktopTableParts table={table} />
              )}
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="rdt-mobile">
          {showTableLoader ? (
            <MobileCardsLoader message="Loading shipping costs…" />
          ) : (
            <MobileCardsOnly table={table} idColId="serial" titleColId="name" actionColId="actions" />
          )}
        </div>
      </div>

      <DataTableStatus
        loading={showTableLoader}
        isEmpty={table.getRowModel().rows.length === 0}
      >
        <div className="mt-4 mb-4">
          <TablePaginationControls table={table} />
        </div>
      </DataTableStatus>
      <DeleteConfirmModal
        open={!!deleteTarget}
        dynamicName={deleteTarget?.name || "Shipping Cost"}
        onCancel={handleDeleteCancel}
        onDelete={handleDeleteConfirm}
      />
    </div>
  );
};

export default SignageShippingCosts;
